import { useApi } from "./api-service";
import { IAgentStatusResponse } from "../../types/api/agent-status";

export function useStatusService() {
  const agentRequired = false; // Set agentRequired to false since we'll handle it manually
  const shouldBuildUrl = false; // Set shouldBuildUrl to false since we'll handle it manually
  const api = useApi(agentRequired, shouldBuildUrl);

  const buildUrl = (agentId: string, endpoint: string): string => {
    return `${process.env.EXPO_PUBLIC_API_BASE}/agents/${agentId}/${endpoint}`;
  };

  return {
    enableAgent: async (agentId: string): Promise<void> => {
      return api.post(buildUrl(agentId, "enable"));
    },

    disableAgent: async (agentId: string): Promise<void> => {
      return api.post(buildUrl(agentId, "disable"));
    },

    pauseAgent: async (
      agentId: string,
      seconds: number
    ): Promise<IAgentStatusResponse> => {
      return api.post(buildUrl(agentId, "pause"), { seconds });
    },
  };
}
